import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInsuredInterestName: {
        id: 'additionalinterest.Name',
        defaultMessage: 'Name',
    },
    additionalInsuredType: {
        id: 'additionalinterest.Relationship To Primary Named Insured',
        defaultMessage: 'Relationship To Primary Named Insured',
    },
    additionalInterestType: {
        id: 'additionalinterest.Interest Type',
        defaultMessage: 'Interest Type',
    },
    additionalType: {
        id: 'additionalinterest.AdditionalType',
        defaultMessage: 'Type',
    },
    additionalInsureds: {
        id: 'additionalinterest.Additional Insureds',
        defaultMessage: 'Additional Insureds',
    },
    additionalInsured: {
        id: 'additionalinterest.Additional Insured',
        defaultMessage: 'Additional Insured',
    },
    additionalNamedInsureds: {
        id: 'additionalinterest.Additional Named Insureds',
        defaultMessage: 'Additional Named Insureds',
    },
    additionalNamedInsured: {
        id: 'additionalinterest.Additional Named Insured',
        defaultMessage: 'Additional Named Insured',
    },
    anotherAdditionalInsured: {
        id: 'additionalinterest.Add Another Additional Insured',
        defaultMessage: 'Add Another Additional Insured?',
    },
    anotherAdditionalNamedInsured: {
        id: 'additionalinterest.Add Another Additional Named Insured',
        defaultMessage: 'Add Another Additional Named Insured?',
    },
    additionalInterests: {
        id: 'additionalinterest.Additional Interests',
        defaultMessage: 'Additional Interests',
    },
    additionalInterest: {
        id: 'additionalinterest.Additional Interest',
        defaultMessage: 'Additional Interest',
    },
    anotherAdditionalInterest: {
        id: 'additionalinterest.Add Another Additional Interest',
        defaultMessage: 'Add Another Additional Interest?',
    },
    additionalInterestName: {
        id: 'additionalinterest.Name',
        defaultMessage: 'Name',
    },
    additionalInterestSave: {
        id: 'additionalinterest.Save',
        defaultMessage: 'Save',
    },
    additionalInterestCancel: {
        id: 'additionalinterest.Cancel',
        defaultMessage: 'Cancel',
    },
    primaryNumber: {
        id: 'additionalinterest.contact-phone-details.Primary number',
        defaultMessage: 'Primary number',
    },
    workPhone: {
        id: 'platform.contacts.templates.contact-template.Work Phone',
        defaultMessage: 'Work Phone',
    },
    description: {
        id: 'additionalinterest.contact-phone-details.Description',
        defaultMessage: 'Description',
    },
    searchExistingContact: {
        id: 'additionalinterest.Search Existing',
        defaultMessage: '-- Search Existing --',
    },
    addNewContact: {
        id: 'additionalinterest.Add New',
        defaultMessage: '--  Add New  --',
    },
    editAdditionalInterest: {
        id: 'additionalinterest.Edit Additional Interest',
        defaultMessage: 'Edit Additional Interest {interestName}',
    },
    deleteAdditionalInterest: {
        id: 'additionalinterest.Delete Additional Interest',
        defaultMessage: 'Delete Additional Interest {interestName}',
    },
    editAdditionalInsured: {
        id: 'additionalinterest.Edit Additional Named Insured',
        defaultMessage: 'Edit Additional Insured {interestName}',
    },
    deleteAdditionalInsured: {
        id: 'additionalinterest.Delete Additional Named Insured',
        defaultMessage: 'Delete Additional Insured {interestName}',
    },
    removeAdditionalInterest: {
        id: 'additionalinterest.Delete Additional Interest2',
        defaultMessage: 'Delete Additional Interest',
    },
    removeAddlnIntMsg: {
        id: 'additionalinterest.Are you want to delete Additional Interest',
        defaultMessage: 'Are you want to delete Additional Interest',
    },
    noneMsg: {
        id: 'additionalinterest.None',
        defaultMessage: 'None'
    },
    aucunMsg: {
        id: 'additionalinterest.Aucun',
        defaultMessage: 'Aucun'
    },
    primaryLocation: {
        id: 'additionalinterest.Primary Location',
        defaultMessage: 'Primary Location'
    },
    emplacementPrincipal: {
        id: 'additionalinterest.Emplacement Principal',
        defaultMessage: 'Emplacement Principal'
    }
});
